<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-2xl max-h-full bg-white shadow-lg rounded-lg overflow-auto px-4"
      >
        <div class="flex flex-col sticky top-0 bg-white pt-5 z-50">
          <div class="flex w-full justify-end mb-4">
            <button
              aria-label="close"
              class="text-xl text-gray-500"
              @click.prevent="close"
            >
              ×
            </button>
          </div>
        </div>

        <template v-if="multimedia.mimeType.includes('image')">
          <img
            :src="replaceURL(multimedia.fileName)"
            class="h-full w-full object-contain"
          />
        </template>

        <template v-if="multimedia.mimeType.includes('video')">
          <video
            :src="replaceURL(multimedia.fileName)"
            class="w-full"
            controls
          ></video>
        </template>

        <div class="flex w-full sticky bottom-0 justify-end pb-5 mt-4 bg-white">
          <button
            class="ml-2 bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
            @click="close()"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "multimedia-modal",
  data() {
    return {};
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    multimedia: {
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    replaceURL(path) {
      return path.replace("./", "../apidev/");
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
